import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
    {
        id: 3,
        label: 'Norm İşlemleri',
        icon: 'bx-folder-open',
        subItems: [
            {
                id: 3,
                label: 'Fazlalık',
                link: '/fazlalik',
                parentId: 2
            },
            {
                id: 4,
                label: 'İhtiyaç',
                link: '/ihtiyac',
                parentId: 2
            },
            {
                id: 5,
                label: 'Ders Yükü',
                link: '/dersyuku',
                parentId: 2
            },
        ]
    },
        


];
export const MENU1: MenuItem[] = [
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
    
        {
        id: 3,
        label: 'Yönetici İşlemleri',
        icon: 'bx-folder-open',
        subItems: [
            {
                id: 3,
                label: 'Fazlalık',
                link: '/admin-fazlalik',
                parentId: 2
            },
            {
                id: 4,
                label: 'İhtiyaç',
                link: '/admin-ihtiyac',
                parentId: 2
            },
            {
                id: 5,
                label: 'Ders Yükü',
                link: '/admin-dersyuku',
                parentId: 2
            },
        ]
    },


];
export const MENU2: MenuItem[] = [
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
    
        {
        id: 3,
        label: 'Yönetici İşlemleri',
        icon: 'bx-folder-open',
        subItems: [
            {
                id: 3,
                label: 'Fazlalık',
                link: '/admin-fazlalik',
                parentId: 2
            },
            {
                id: 4,
                label: 'İhtiyaç',
                link: '/admin-ihtiyac',
                parentId: 2
            },
            {
                id: 5,
                label: 'Ders Yükü',
                link: '/admin-dersyuku',
                parentId: 2
            },
        ]
    },
       {
        id: 4,
        label: 'Ayarlar',
        link: '/ayarlar',
        icon:'bx-cog'
    },
       {
        id: 5,
        label: 'Personel',
        link: '/user',
        icon:'bx-user'
    },
      {
        id: 6,
        label: 'Okullar',
        link: '/okullar',
        icon:'bxs-school'
    },

];
